import {
    Button,
    DateRangeField,
    Form,
    FormFooter,
    FormSection,
    Page,
    toast
} from '@7shifts/sous-chef';
import { getTicketsClosedReasonsReport } from 'api/reportsApi';
import { useFormik } from 'formik';
import { __ } from 'i18n/translate';
import UserSelectField from 'sharedComponents/UserSelectField';
import { downloadCSV } from 'utils/csv';
import { dateYearMonthDay } from 'utils/date';

type FormData = {
    date: { start: Date; end: Date };
    user: { key: string; value: string } | undefined;
};

const TicketsClosedReasonsPage = () => {
    const formik = useFormik<FormData>({
        initialValues: {
            date: {
                start: new Date(),
                end: new Date()
            },
            user: undefined
        },
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            getTicketsClosedReasonsReport(
                dateYearMonthDay(values.date.start),
                dateYearMonthDay(values.date.end),
                values.user ? +values.user.value : undefined
            )
                .then((data) => {
                    downloadCSV(data, 'tickets-closed-reason.csv');
                })
                .catch(() => {
                    toast('Something went wrong', 'danger');
                })
                .finally(() => formik.setSubmitting(false));
        }
    });

    return (
        <Page
            breadcrumbs={__('main.reports')}
            title={__('reportsPage.reportTicketsClosedReason')}
            subtitle={__('reportsPage.reportTicketsClosedReasonDescription')}
        >
            <Form formik={formik}>
                <FormSection as="card">
                    <DateRangeField
                        name="date"
                        label="Período"
                        format="dd/MM/yyyy"
                        disabledDays={{
                            after: new Date()
                        }}
                    />
                    <UserSelectField
                        name="user"
                        placeholder={__('dashboardPage.allUsers')}
                        label="Usuário"
                        onChange={(userOption) =>
                            formik.setFieldValue('user', userOption)
                        }
                    />
                </FormSection>
                <FormFooter
                    actions={{
                        primary: (
                            <Button type="submit" loading={formik.isSubmitting}>
                                {__('main.downloadCSV')}
                            </Button>
                        )
                    }}
                />
            </Form>
        </Page>
    );
};

export default TicketsClosedReasonsPage;
